import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SubscriptionsManager } from '../util/subscriptions-manager';
import { PropertyService } from '../ontology/service/property.service';

@Component({
    selector: 'jhi-column-filter-properties',
    template: `
		<form #f='ngForm'>
			<section class="filter-wrapper">
				<div class="keyword-wrapper">
					<input type="text" class="form-control" [formControl]="queryField" id="keyword" placeholder="{{ propertiesPlaceholder | translate }}" autofocus/>
				</div>
				<ul class="filter-select">
					@if (results.length > 0) {
						<li *ngFor="let result of results" class="filter-select-list" (click)="addProperty(result)">
							<div class="result-line mt-2 ms-2">
								<span class="label-info fw-bold">{{ 'column-filter.name' | translate }}:</span>
								<span>{{ result.name }}</span>
							</div>
							<div class="result-line ms-2">
								<span class="label-info fw-bold">{{ 'column-filter.description' | translate }}:</span>
								<span class="result-value">{{ result.description }}</span>
							</div>
						</li>
					}
				</ul>
			</section>
			@if (filter.properties.length === 0) {
				<div class="empty-selection">
					<span>{{ 'column-filter.properties.label' | translate }}</span>
				</div>
			} @else {
				<div class="selected-items-container mt-2">
					<div *ngFor="let property of filter.properties" class="selected-chip">
						<button type="button" class="chip-remove" (click)="deleteProperty(property)" aria-label="Remove property"> ×</button>
						<span class="chip-text">{{ property.name }}</span>
					</div>
				</div>
			}
			<br/>
			<div class="footer text-center">
				<br>
				<button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
				<button type="button" class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
			</div>
		</form>
    `
})
export class ColumnFilterPropertiesComponent implements OnInit, OnDestroy {

    queryField: FormControl = new FormControl();
    results: any[] = [];

    @Input() filter: any;
    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();
    propertiesPlaceholder: string;

    subscriptionManager = new SubscriptionsManager();

    constructor(private propertyService: PropertyService) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.subscriptionManager.add = this.queryField.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((query) => this.propertyService.queryProperties(query))
            ).subscribe((result: any) => {
                if (result.status === 400) {
                    this.results = [];
                    return;
                }
                this.results = result.body || [];
            });
        this.propertiesPlaceholder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.search.text.placeholder';
    }

    addProperty(property) {
        // Reset query field value
        this.queryField.setValue('');
        // Do not add properties if it's already in the list
        if (!this.filter.properties.some((e) => e.name === property.name)) {
            this.filter.properties.push({ ...property });
        }
    }

    deleteProperty(property) {
        this.filter.properties = this.filter.properties.filter((e) => e.name !== property.name);
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
